/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * User information about a User in the System.
 */
export type UserInfo = {
  /**
   * Email of the user.
   */
  email: string;
  /**
   * First name of the user.
   */
  firstName: string;
  /**
   * ID of the user.
   */
  id: string;
  /**
   * Last name of the user.
   */
  lastName: string;
};

/** @internal */
export const UserInfo$inboundSchema: z.ZodType<
  UserInfo,
  z.ZodTypeDef,
  unknown
> = z.object({
  email: types.string(),
  first_name: types.string(),
  id: types.string(),
  last_name: types.string(),
}).transform((v) => {
  return remap$(v, {
    "first_name": "firstName",
    "last_name": "lastName",
  });
});
/** @internal */
export type UserInfo$Outbound = {
  email: string;
  first_name: string;
  id: string;
  last_name: string;
};

/** @internal */
export const UserInfo$outboundSchema: z.ZodType<
  UserInfo$Outbound,
  z.ZodTypeDef,
  UserInfo
> = z.object({
  email: z.string(),
  firstName: z.string(),
  id: z.string(),
  lastName: z.string(),
}).transform((v) => {
  return remap$(v, {
    firstName: "first_name",
    lastName: "last_name",
  });
});

export function userInfoToJSON(userInfo: UserInfo): string {
  return JSON.stringify(UserInfo$outboundSchema.parse(userInfo));
}
export function userInfoFromJSON(
  jsonString: string,
): SafeParseResult<UserInfo, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UserInfo$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UserInfo' from JSON`,
  );
}
